import { SearchBarWithAvatarsSelectedProps } from "../types"
import React from "react"
import { observer } from "mobx-react-lite"
import { Avatar } from "~widgets/avatar"
import styled from '~/ui/styled'

const Wrap = styled.View`
  flex-direction: row;
`
const RightGap = styled.View`
  margin-right: 5px;
`

interface AvatarsProps {
  selecteds: SearchBarWithAvatarsSelectedProps[]
}

const Avatars: React.FC<AvatarsProps> = ({ selecteds }) => {
  return (
    <Wrap>
      {selecteds.slice(0, 5).map((s, i) => {
        return (
          <RightGap key={`${i}-${s.title}`}>
            <Avatar size={36} name={s.title} avatar={s.avatar} />
          </RightGap>
        )
      })}
    </Wrap>
  )
}

export default observer(Avatars)
